/* eslint-disable */
export default {
  unknown: '알 수 없음',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
